import { render, staticRenderFns } from "./TaskHistoryComments.vue?vue&type=template&id=d036fbc8&scoped=true"
import script from "./TaskHistoryComments.vue?vue&type=script&lang=js"
export * from "./TaskHistoryComments.vue?vue&type=script&lang=js"
import style0 from "./TaskHistoryComments.vue?vue&type=style&index=0&id=d036fbc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d036fbc8",
  null
  
)

export default component.exports